import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export interface HandoverPreferencesResponse {
  handover_preferences: string[];
}

export function useHandoverPreferences() {
  return useQuery<HandoverPreferencesResponse>({
    queryKey: [APIKey.HANDOVER_PREFERENCES],
    queryFn: () => baseFetcher(apiRoutes.handoverPreferences()),
  });
}

export function useUpdateHandoverPreferences() {
  const queryClient = useQueryClient();

  return useMutation<
    HandoverPreferencesResponse,
    unknown,
    HandoverPreferencesResponse
  >({
    mutationFn: (data) =>
      baseFetcher(apiRoutes.handoverPreferences(), {
        method: 'PATCH',
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [APIKey.HANDOVER_PREFERENCES],
      });
      queryClient.invalidateQueries({ queryKey: [APIKey.USER] });
      queryClient.invalidateQueries({ queryKey: [APIKey.HANDOVER] });
    },
  });
}
